<template>
  <div class="col-md-12">
    <div class="w-block" style="padding: 2px;">
      <el-date-picker v-model="year" type="year" placeholder="选择年" @change="getList">
      </el-date-picker>
    </div>
    <wgrid :data="grid.ls" v-loading="grid.loading" :pageShow="false">
      <el-table-column prop="TitleStart" label="日期" width="180" align="center"></el-table-column>
      <el-table-column prop="AllCount" label="总计" align="center"></el-table-column>
      <el-table-column label="正常" align="center">
        <template slot-scope="scope">
          <span :style="{color: scope.row.NomalCount>0?'#3bb667':''}">{{ scope.row.NomalCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ErrCount" label="异常" align="center">
        <template slot-scope="scope">
          <span :style="{color: scope.row.ErrCount>0?'red':''}">{{ scope.row.ErrCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnCheckCount" label="未检" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="310px">
        <template slot-scope="{row}">
          <el-button type="success" size="mini" icon="el-icon-plus" @click="supplement(row)">补录记录</el-button>
          <el-button type="primary" size="mini" @click="getDetailList(row.Details)">项目类型</el-button>
          <el-button type="primary" size="mini" @click="getConfigList(row.Configs)">未检项目</el-button>
        </template>
      </el-table-column>
    </wgrid>
    <el-dialog :visible="showDetailList" :before-close="handleClose">
      <span slot="title">项目类型</span>
      <el-table :data="detailList" height="60vh">
        <el-table-column label="项目类型" align="center">
          <template slot-scope="{row}">
            <span :style="{color: !row.ConfigTypeId?'red':'#000'}">{{ row.ConfigTypeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="TypeCount" label="需检" align="center"></el-table-column>
        <el-table-column prop="CheckCount" label="已检" align="center"></el-table-column>
        <el-table-column prop="UnCheckCount" label="未检" align="center">
          <template slot-scope="{row}">
            <span :style="{color: row.UnCheckCount>0?'red':'#000'}">{{ row.UnCheckCount }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible="showConfigList" :before-close="handleClose">
      <span slot="title">未检项目</span>
      <el-table :data="configList" height="60vh">
        <el-table-column prop="Name" label="名称" align="center"></el-table-column>
        <el-table-column prop="Type" label="类型" align="center">
          <template slot-scope="{row}">{{row.Type || '-'}}</template>
        </el-table-column>
        <el-table-column prop="Loca" label="位置" align="center">
          <template slot-scope="{row}">{{row.Loca || '-'}}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Wgrid from "@/components/wgrid";
import {getYearRange} from "@/util";
import Swal from "sweetalert2";

export default {
  name: "AF",
  components: {Wgrid},
  props: ['type'],
  data() {
    return {
      grid: {
        ls: [],
        loading: false
      },
      year: '',
      rows: [],
      showConfigList: false,
      showDetailList: false,
      configList: [],
      detailList: [],
    }
  },
  watch: {},
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let self = this;
      this.grid.loading = true;
      this.whale.remote.getResult({
        url: "api/School/SAFE/RecApi/GetAllDataV2",
        data: {
          Safe_Class_Id: self.type.ID,
          Safe_Class_Name: self.type.Safe_Class_Name,
          DTS: getYearRange(this.year).DTS,
          DTE: getYearRange(this.year).DTE,
        },
        completed: function (its) {
          self.grid.loading = false;
          self.grid.ls = its.DATA;
        },
        failure: function (err) {
          Swal.fire({
            title: "出错啦",
            text: err,
            icon: "error",
            cancelButtonText: "关闭",
            showCancelButton: true,
            showConfirmButton: false,
          });
          self.grid.loading = false;
          self.grid.ls = [];
        }
      })
    },
    getDetailList(rows) {
      this.detailList = rows;
      this.showDetailList = true;
    },
    getConfigList(rows) {
      this.configList = rows;
      this.showConfigList = true;
    },
    supplement(row) {
      const date = row.TitleStart;
      this.$confirm(`将自动补录 ${date} 当天尚未巡检的消防项目，只需要确认日期，无需填写其他数据。是否继续？`, "补录消防巡检记录", {
        confirmButtonText: "确认补录",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.grid.loading = true;
        this.whale.remote.getResult({
          url: "api/School/SAFE/RecApi/SupplementFireData",
          data: { DATE: date },
          completed: response => {
            const result = response.DATA || {};
            if ((result.SupplementCount || 0) > 0) {
              this.$message.success(`${result.Date} 补录完成，共补录 ${result.SupplementCount} 条记录`);
            } else {
              this.$message.info(`${result.Date || date} 没有需要补录的消防项目`);
            }
            this.getList();
          },
          finally: () => { this.grid.loading = false; }
        });
      }).catch(() => {});
    },
    handleClose() {
      this.showConfigList = false;
      this.showDetailList = false;
    }
  }
}
</script>

<style scoped>

</style>
